
import Vue from 'vue'
import { apiService } from '../service/api.service'
import jwtService from '../service/jwt.service'
import store from '../store/index'

export default Vue.extend({
  name: 'AdminLogin',

  data: () => ({
    valid: true,
    showPassword: false,
    email: '',
    password: '',
    loading: false,
    error: '',
    features: [
      { icon: 'mdi-account-group-outline', text: 'User & Licence Management' },
      { icon: 'mdi-cellphone-link', text: 'Device & Container Control' },
      { icon: 'mdi-chart-line', text: 'Platform Analytics & Logs' },
      { icon: 'mdi-email-multiple-outline', text: 'Email Campaigns & Settings' }
    ],
    rules: {
      required: (value: string) => !!value || 'Required.',
      email: (value: string) => {
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    }
  }),

  methods: {
    async onSubmit () {
      const form = this.$refs.form as any
      if (!form.validate()) return

      this.loading = true
      this.error = ''

      try {
        const res: any = await apiService.post('login', {
          email: this.email,
          password: this.password
        })

        const data = res.data
        if (!data.token) {
          this.error = data.message || 'Login failed.'
          return
        }

        const roles: string[] = (data.user_info?.roles || [])
        if (!roles.includes('admin')) {
          this.error = 'Access denied. This panel is for administrators only.'
          return
        }

        jwtService.saveToken(data.token)
        store.dispatch('setAuthenticated', true)
        store.commit('setUser', data.user_info)
        this.$router.replace({ name: 'dashboard' })
      } catch (err: any) {
        const msg = err?.response?.data?.message
        this.error = msg || 'An error occurred. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
})
